/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GlobalUptimeResponse
 */
export interface GlobalUptimeResponse {
    /**
     *
     * @type {string}
     * @memberof GlobalUptimeResponse
     */
    deviceGroupTag?: string;
    /**
     * Uptime as a fraction between 0 and 1, where 1 = 100% uptime. Note: despite the name this is not a percentage.
     * @type {number}
     * @memberof GlobalUptimeResponse
     */
    uptimePercentage?: number;
    /**
     * Percentage difference in uptime (based on UptimePercentage) from the previous period, can be null if previous period does not have data.
     * @type {number}
     * @memberof GlobalUptimeResponse
     */
    diffPercentage?: number;
    /**
     *
     * @type {Date}
     * @memberof GlobalUptimeResponse
     */
    periodStart?: Date;
    /**
     *
     * @type {Date}
     * @memberof GlobalUptimeResponse
     */
    periodEnd?: Date;
}

/**
 * Check if a given object implements the GlobalUptimeResponse interface.
 */
export function instanceOfGlobalUptimeResponse(
    value: object,
): value is GlobalUptimeResponse {
    return true;
}

export function GlobalUptimeResponseFromJSON(json: any): GlobalUptimeResponse {
    return GlobalUptimeResponseFromJSONTyped(json, false);
}

export function GlobalUptimeResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): GlobalUptimeResponse {
    if (json == null) {
        return json;
    }
    return {
        deviceGroupTag:
            json["deviceGroupTag"] == null ? undefined : json["deviceGroupTag"],
        uptimePercentage:
            json["uptimePercentage"] == null
                ? undefined
                : json["uptimePercentage"],
        diffPercentage:
            json["diffPercentage"] == null ? undefined : json["diffPercentage"],
        periodStart:
            json["periodStart"] == null
                ? undefined
                : new Date(json["periodStart"]),
        periodEnd:
            json["periodEnd"] == null ? undefined : new Date(json["periodEnd"]),
    };
}

export function GlobalUptimeResponseToJSON(
    value?: GlobalUptimeResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceGroupTag: value["deviceGroupTag"],
        uptimePercentage: value["uptimePercentage"],
        diffPercentage: value["diffPercentage"],
        periodStart:
            value["periodStart"] == null
                ? undefined
                : value["periodStart"].toISOString(),
        periodEnd:
            value["periodEnd"] == null
                ? undefined
                : value["periodEnd"].toISOString(),
    };
}
